export default __webpack_public_path__ + "static/media/G_D_btn__Magento.1254c486.svg";